import {$t, $tc} from "@/i18n";
import DialogModule from "../../store/modules/dialog";
import SalesInvoiceModule from "../../store/modules/sales_invoice";
import {isRef} from "@vue/composition-api";
import AccountModule from "../../store/modules/account";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default function (account_id, selected_invoices, callback) {
    if (!isRef(selected_invoices)) return console.error("Invoice create :: selected invoices must be referenced");
    let invoice_id_list = [];
    const {getCreatableInvoices, calculateSalesInvoices, getInProgressInvoices} = SalesInvoiceModule();
    const {setConfirmOptions, openConfirmDialog} = DialogModule();
    const {isFeatureEnabled} = AccountModule();
    const onAction = async () => {
        let invoice_status = 'created';
        calculateSalesInvoices(account_id, invoice_id_list, invoice_status)
            .then(function () {
                for (const invoice of Array.from(selected_invoices.value)) {
                    if (Array.from(invoice_id_list).includes(invoice.id)) {
                        invoice.process_status = "create_invoice";
                    }
                }
                if (callback) callback();
            })
            .catch(ex => errorDialog.showError(ex));
    };

    let modal_icon = "";
    const confirm_dialog_message = () => {
        let creatable_invoices_count = getCreatableInvoices(selected_invoices.value).length;
        let not_creatable_invoices_count = selected_invoices.value.length - creatable_invoices_count;
        let in_progress_invoices_count = getInProgressInvoices(selected_invoices.value).length;
        if (not_creatable_invoices_count > 0 && in_progress_invoices_count < 1) {
            modal_icon = "mdi-alert-circle-outline";
            return (
                $t("Out of ") +
                selected_invoices.value.length +
                $tc(" selected row, only | selected row, only ", selected_invoices.value.length) +
                creatable_invoices_count +
                $tc(" invoice | invoices", creatable_invoices_count) +
                $t(" can be created")
            );
        } else if (in_progress_invoices_count >= 1) {
            modal_icon = "mdi-alert-circle-outline";
            return (
                $t("Warning") + " " + $t("For ") + ' ' + in_progress_invoices_count + " " + $tc(" invoice | invoices", in_progress_invoices_count) + ":"
                + "<ul>"
                + "<li>" + $t(" invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.") + "</li>"
                + "<li>" + $t("Invoice date will be set to today.") + "</li>"
                + "</ul>"
            );
        } else {
            modal_icon = "";
            return "";
        }
    };

    const onCreateInvoicesClick = () => {
        account_id = account_id ? account_id : selected_invoices.value[0].account_id;
        if (!isFeatureEnabled(account_id, "billing")) return;

        invoice_id_list = getCreatableInvoices(selected_invoices.value).map(invoice => invoice.id);
        let title = "{0} {1} {2}".format(
            $t("Uku is about to create"),
            invoice_id_list.length,
            $tc(" invoice | invoices", invoice_id_list.length)
        );
        let text = confirm_dialog_message();
        setConfirmOptions({
            title: title,
            text: text,
            confirm_text: $t("Continue"),
            cancel_text: $t("Cancel"),
            icon: modal_icon,
            action: onAction,
        });
        openConfirmDialog();
    };
    return {onCreateInvoicesClick};
};
